export default __webpack_public_path__ + "static/media/tag.93055fe7.png";